const formatSpaces = (word) => {
    if (word && typeof word === 'string') {
        return word.replace(/ +/g, ' ').trim();
    }
    return word;
};
export default formatSpaces;
